import { REDESIGN_ASSETS } from '../constants'

interface LogoStripProps {
  className?: string
  // Renders the strip as an infinite auto-scrolling marquee (ribbon variant)
  marquee?: boolean
}

// DOM keeps the approved mobile order; the desktop order from Figma
// (F1, Coachella, Pádel, Afterwork, Champions) is applied via CSS `order`.
const LOGOS = [
  { key: 'afterwork', file: 'home-franja_logos-afterwork', alt: 'Afterwork' },
  { key: 'coachella', file: 'home-franja_logos-coachella', alt: 'Coachella' },
  { key: 'champions', file: 'home-franja_logos-champions league', alt: 'Champions League' },
  { key: 'f1', file: 'home-franja_logos-formula1', alt: 'Fórmula 1' },
  { key: 'padel', file: 'home-franja_logos-padel', alt: 'Premier Pádel' }
]

// Brand logo strip shared by the hero ribbon (>=1024px) and the membership
// section. Desktop art is served through <picture> sources.
const LogoStrip = ({ className, marquee }: LogoStripProps) => {
  const items = LOGOS.map(({ key, file, alt }) => (
    <picture key={key} className={`home-v3__franja-item home-v3__franja-item--${key}`}>
      {/* encodeURI: srcSet treats a raw space as the URL/descriptor separator */}
      <source media="(min-width: 1024px)" srcSet={encodeURI(`${REDESIGN_ASSETS}/desktop/${file}-desktop1280px.webp`)} />
      <source media="(min-width: 768px)" srcSet={encodeURI(`${REDESIGN_ASSETS}/tablet/${file}-tablet.webp`)} />
      <img src={encodeURI(`${REDESIGN_ASSETS}/${file}-mobile.webp`)} alt={alt} className="home-v3__franja-logo" />
    </picture>
  ))

  if (!marquee) {
    return <div className={`home-v3__franja ${className ?? ''}`.trim()}>{items}</div>
  }

  // Marquee track: four identical groups, so the -50% keyframe lands exactly
  // on a copy (no visible seam) and the half-track period always exceeds the
  // viewport width (no empty gap at the loop extremes).
  return (
    <div className={`home-v3__franja home-v3__franja--marquee ${className ?? ''}`.trim()}>
      <div className="home-v3__franja-track">
        <div className="home-v3__franja-group">{items}</div>
        {[1, 2, 3].map((copy) => (
          <div key={copy} className="home-v3__franja-group" aria-hidden="true">
            {items}
          </div>
        ))}
      </div>
    </div>
  )
}

export default LogoStrip
